var Filter = /** @class */ (function () {
    function Filter() {
        this.filters = [];
    }
    Filter.create = function () {
        return new Filter();
    };
    Filter.byUniqueName = function (uniqueName) {
        return new Filter().addUniqueName(uniqueName);
    };
    Filter.by = function (dimension, hierarchy, member) {
        return new Filter().add(dimension, hierarchy, member);
    };
    Filter.prototype.addUniqueName = function (uniqueName) {
        this.filters.push(uniqueName);
        return this;
    };
    Filter.prototype.add = function (dimension, hierarchy, member) {
        this.filters.push("[" + dimension + "].[" + hierarchy + "].&[" + member + "]");
        return this;
    };
    Filter.prototype.toGlobalEmbedFilters = function () {
        return this.filters.map(function (x) {
            return { value: x };
        });
    };
    return Filter;
}());
export { Filter };
